import axios from "axios";

const sigInUrl =
  //"https://prod-185.westus.logic.azure.com:443/workflows/4e2b8c2ff5b543ffaa02c804dd767d7f/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=97pO89vpLFdcz4iv5M13kasm2LjMZRpl1QZeHL4r0CU%22;
  "https://24f3714eebe9433cb6de66089bbc0b.33.environment.api.powerplatform.com/powerautomate/automations/direct/workflows/4e2b8c2ff5b543ffaa02c804dd767d7f/triggers/manual/paths/invoke/18072024?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=aoPeBvtv3-0PgnLKL_i6SgO4liISpr3VXFbpQbB5JWE";
const changePassUrl =
  //"https://prod-120.westus.logic.azure.com:443/workflows/b0548d8717c74d9082284bdb86ffc5f4/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=-6ZgSJfn61L7ZXflCUXLSCrZ7ugjIn9376MIoCD5Rq8%22;
"https://24f3714eebe9433cb6de66089bbc0b.33.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/b0548d8717c74d9082284bdb86ffc5f4/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=_kUCnvlF1XMjfLDP1MGNVjSHisYPAC-HgTgBjVc0NPw";
export const sigIn = (username, password) => {
  const params = {Usuario: username, Contrasena: password};
  return axios.post(sigInUrl, params);
};

export const changePassword = (username, password) => {
  const params = {Usuario: username, Contrasena: password};
  return axios.post(changePassUrl, params);
};